import React from 'react'
import {
  InputGroup,
  InputGroupAddon,
  Button,
  Form,
  FormGroup,
  Input,
  Alert,
} from 'reactstrap'
import MaskedInput from 'react-maskinput'

const LoginForm = ({ phone, onChange, err, buttonText, onClick }) => (
  <Form onSubmit={onClick}>
    <FormGroup className={`${phone ? 'has-success' : ''} d-flex flex-column`}>
      <InputGroup>
        <InputGroupAddon className="" addonType="prepend">
          +7
        </InputGroupAddon>
        <Input
          valid={phone ? true : false}
          disabled={phone ? true : false}
          readOnly={phone ? true : false}
          className="login_bg "
          type="tel"
          onChange={onChange}
          name="phone"
          placeholder="Телефон"
          mask="(000)-000-00-00"
          tag={MaskedInput}
        />
      </InputGroup>
      {err &&
        err.phone && (
          <Alert className="mt-2" color="danger">
            {err.phone}
          </Alert>
        )}
    </FormGroup>

    {phone && (
      <FormGroup className="d-flex flex-column">
        <Input
          invalid={err && err.code ? true : false}
          type="tel"
          onChange={onChange}
          name="code"
          placeholder="Пароль"
        />
        {err &&
          err.code && (
            <Alert className="mt-2" color="danger">
              {err.code}
            </Alert>
          )}
      </FormGroup>
    )}

    <Button onClick={onClick} outline color="warning" block>
      {buttonText}
    </Button>
  </Form>
)

export default LoginForm



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm.js